/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_Filterfiles1Inputs */

const id_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter file...`)
};

const ms_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapis fail...`)
};

const da_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrér filer...`)
};

const de_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien filtern...`)
};

const en_us2_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter files...`)
};

const es_es2_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar archivos...`)
};

const es_mx2_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar archivos...`)
};

const fil_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-filter ang mga file...`)
};

const fr_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer les fichiers…`)
};

const it_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra file...`)
};

const hu_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fájlok szűrése...`)
};

const nl_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter bestanden...`)
};

const no_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer filer...`)
};

const pl_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtruj pliki...`)
};

const pt_br2_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter files...`)
};

const pt_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar ficheiros...`)
};

const ro_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrează fișierele...`)
};

const fi_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suodata tiedostoja...`)
};

const sv_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrera filer...`)
};

const vi_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc tệp...`)
};

const tr_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosyaları filtrele...`)
};

const cs_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat soubory...`)
};

const bg_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Филтриране на файлове...`)
};

const ru_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр файлов...`)
};

const uk_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтрувати файли...`)
};

const ar_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية الملفات...`)
};

const hi_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइलें फ़िल्टर करें...`)
};

const th_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรองไฟล์...`)
};

const ja_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルをフィルター...`)
};

const zh_cn2_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter files...`)
};

const zh_hant1_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter files...`)
};

const ko_table_toolbar_filterfiles1 = /** @type {(inputs: Table_Toolbar_Filterfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter files...`)
};

/**
* | output |
* | --- |
* | "Filter files..." |
*
* @param {Table_Toolbar_Filterfiles1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_filterfiles1 = /** @type {((inputs?: Table_Toolbar_Filterfiles1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_Filterfiles1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_filterfiles1(inputs)
	if (locale === "ms") return ms_table_toolbar_filterfiles1(inputs)
	if (locale === "da") return da_table_toolbar_filterfiles1(inputs)
	if (locale === "de") return de_table_toolbar_filterfiles1(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_filterfiles1(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_filterfiles1(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_filterfiles1(inputs)
	if (locale === "fil") return fil_table_toolbar_filterfiles1(inputs)
	if (locale === "fr") return fr_table_toolbar_filterfiles1(inputs)
	if (locale === "it") return it_table_toolbar_filterfiles1(inputs)
	if (locale === "hu") return hu_table_toolbar_filterfiles1(inputs)
	if (locale === "nl") return nl_table_toolbar_filterfiles1(inputs)
	if (locale === "no") return no_table_toolbar_filterfiles1(inputs)
	if (locale === "pl") return pl_table_toolbar_filterfiles1(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_filterfiles1(inputs)
	if (locale === "pt") return pt_table_toolbar_filterfiles1(inputs)
	if (locale === "ro") return ro_table_toolbar_filterfiles1(inputs)
	if (locale === "fi") return fi_table_toolbar_filterfiles1(inputs)
	if (locale === "sv") return sv_table_toolbar_filterfiles1(inputs)
	if (locale === "vi") return vi_table_toolbar_filterfiles1(inputs)
	if (locale === "tr") return tr_table_toolbar_filterfiles1(inputs)
	if (locale === "cs") return cs_table_toolbar_filterfiles1(inputs)
	if (locale === "bg") return bg_table_toolbar_filterfiles1(inputs)
	if (locale === "ru") return ru_table_toolbar_filterfiles1(inputs)
	if (locale === "uk") return uk_table_toolbar_filterfiles1(inputs)
	if (locale === "ar") return ar_table_toolbar_filterfiles1(inputs)
	if (locale === "hi") return hi_table_toolbar_filterfiles1(inputs)
	if (locale === "th") return th_table_toolbar_filterfiles1(inputs)
	if (locale === "ja") return ja_table_toolbar_filterfiles1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_filterfiles1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_filterfiles1(inputs)
	return ko_table_toolbar_filterfiles1(inputs)
});
export { table_toolbar_filterfiles1 as "table.toolbar.filterFiles" }